mutation MarkExploreAttentionBadgeAsSeen {
    exploreAttentionBadgeMarkAsSeen {
        success
    }
}
